
//Dev Public Environment
//export const baseUrl = 'https://www.popms-devapi-eu.net/pet-owner-platform/v1/dev/2-2v1';
//Dev Internal Environment
//export const baseUrl = 'https://vpce-0a6b12a2c6fb98a2d-1pdxd114.execute-api.eu-west-1.vpce.amazonaws.com/dev/2-2v1';
//Production Environment
export const baseUrl = 'https://www.popms-prdapi-eu.net/pet-owner-platform/v1/prod/2-2v1';
